export enum OrdersAssignmentType {
  Classify,
  Assign,
  Plan,
}
